export default __webpack_public_path__ + "static/media/snow_black.4b6a772f.svg";